import { render } from "./ClearAllFiltersButton.vue?vue&type=template&id=2274e863"
import script from "./ClearAllFiltersButton.vue?vue&type=script&lang=js"
export * from "./ClearAllFiltersButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__